let title = ' | Gestor - Comercial Ivaiporã'

const sorteio = {
    path: '/sorteio',
    props: true,
    component: () => import('@/Components/Sorteio/SorteioContainer'),
    children: [
        {
            path: '',
            name: 'SorteioLista',
            component: () => import('@/Components/Sorteio/SorteioLista'),
            meta: {
                title: 'Sorteios e Cupons' + title,
                permission: 'sorteio_listar',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Sorteios e Cupons',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '',
                    }
                ]
            }
        },
    ]
}

export default sorteio